import React, {useState, useEffect} from "react";
import { Colors } from "../../common/Const";
import Footer from "./Footer";
import Header from "./Header";

function PrivacyPolicy() {
  const [windowSize, setWindowSize] = useState(window.innerWidth)
  // console.log("permission", option)
  useEffect(() => {
      const handleResize = () => {
        setWindowSize(window.innerWidth)
      }
  
      window.addEventListener('resize', handleResize)
  
      return () => window.removeEventListener('resize', handleResize)
    }, [])
  return (
    <div style={{backgroundColor: Colors.bg_color}}>
      <Header make={true} />
        {/* <div className="container p-3" id="aboutUs" >
            <div dangerouslySetInnerHTML={{ __html: page.privacy_policy_text }} />
        </div> */}
      <div className="d-flex flex-column container py-3">
        <p className={ windowSize > 540 ? "mt-5 mb-4" : "my-2 mx-0"} style={{fontSize: windowSize > 540 ? '30px' : '20px', color: Colors.Base_color}}>Privacy Policy</p>
        <span className="privacy-txt">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</span>
        <span className="privacy-txt">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</span>
        <span className="privacy-txt">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</span>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
